import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-16 sm:py-24 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <p className="text-base sm:text-xl text-accent-200 font-display italic mb-4">
          &ldquo;We Create Our Own Destiny&rdquo;
        </p>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4 sm:mb-6 leading-tight">
          Choose Our Partnership as Your Shortcut to Success
        </h2>
        <p className="text-base sm:text-xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed">
          Join a <strong>proven Malaysian conglomerate</strong> that fuses physical business assets with AI technology. Whether you prefer hands-on management or passive income — we have the perfect partnership for you.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Link
            to="/investor-relations"
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white hover:bg-gray-100 text-primary-600 font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base text-center"
          >
            Explore Investment Opportunities
          </Link>
          <a
            href="https://wa.me/60122353795"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg backdrop-blur-sm transition-all border border-white/30 whitespace-nowrap cursor-pointer inline-flex items-center justify-center space-x-2 text-sm sm:text-base"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            <span>WhatsApp Us Now</span>
          </a>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">30+</div>
            <div className="text-sm sm:text-base text-white/80">Years of Legacy</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">6</div>
            <div className="text-sm sm:text-base text-white/80">Revenue Streams</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">5</div>
            <div className="text-sm sm:text-base text-white/80">Continents Served</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-white mb-2">AI</div>
            <div className="text-sm sm:text-base text-white/80">Powered Operations</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
